module.exports = __webpack_public_path__ + "img/ic_group_center_right_img.bf91f61a.png";